export const LEAD_TYPES_META = [
  { name: "fsbo", label: "FSBO" },
  { name: "canceled", label: "Canceled" },
  { name: "expired", label: "Expired" },
  { name: "withdrawn", label: "Withdrawn" },
  { name: "nod", label: "NOD" },
  { name: "probate", label: "Probate" },
  { name: "tax_liens", label: "Tax Liens" },
  { name: "divorce", label: "Divorce" },
];

export const PROPERTY_TYPES = [
  "Single Family",
  "Mobile Home",
  "Condominium",
  "Land",
  "Multi-Family",
  "Townhouse",
  "Other",
];

export const STATUS_DISPLAY = {
  fsbo: "FSBO",
  canceled: "Canceled",
  expired: "Expired",
  withdrawn: "Withdrawn",
  nod: "NOD",
  probate: "Probate",
  tax_liens: "Tax Liens",
  divorce: "Divorce",
};
